import React from "react";
import { Form } from "react-bootstrap";
import PrimaryButton from "../../components/PrimaryButton";
import FixedColumnsTable from "../../components/FixedColumnsTable";
import PaginationComponent from "../../components/PaginationComponent";
import useMappingManagementViewController from "../../viewControllers/MappinManagementControllers/MappingManagementViewController";
import Loader from "../../components/Loader";
import i18n from "../../constants/Strings";

const MappingManagement = () => {

  const {
    goBack,
    mappingList,
    currentPage,
    pageSize,
    totalPages,
    handlePageChange,
    navigate,
    columns,
    loading,
  } = useMappingManagementViewController();

  const text = {
    backBtn: i18n.t('mappingManagement.backBtn'),
    createMapping: i18n.t('mappingManagement.createMapping'),
    mappingSKUsToGWP: i18n.t('mappingManagement.mappingSKUsToGWP'),
    noMappingFound: i18n.t('mappingManagement.noMappingFound'),

  }
  return (
    <>
      {loading ? <Loader /> : (
        <div>
          <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">
            <Form className="d-none d-sm-inline-block form-inline mr-auto ml-md-3 my-2 my-md-0 navbar-search">
              <div className="d-flex justify-space-between">
                <h6 className="back-btn" onClick={goBack}>{text.backBtn}</h6>
                <div className="mapping-create-btn">
                  <PrimaryButton
                    text={text.createMapping}
                    className="login-btn"
                    onClick={() => navigate("/create-mapping")}
                  />
                </div>
              </div>
            </Form>
          </nav>
          <div className="container-fluid">
            <div className=" mb-4">
              <div className="card-header py-3">
                <h6 className="m-0 font-weight-bold txt-primary">
                  {text.mappingSKUsToGWP}
                </h6>
              </div>
              {mappingList?.length > 0 ? (
                <>
                  <FixedColumnsTable columns={columns} data={mappingList} />
                  <PaginationComponent
                    currentPage={currentPage}
                    pageSize={pageSize}
                    totalPages={totalPages}
                    onPageChange={handlePageChange}
                    totalLength={mappingList?.length}
                  />
                </>
              ) : (
                <div className="mt-4">{text.noMappingFound}</div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default MappingManagement;
